import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function VwMsgInBox ( props ) {

    const { onSelect, onInitialized, ...others } = props;

    const onGridInitialized = (grid) => {

        grid.selectionMode = "ListBox";
        
        if (grid) {

            grid.selectionChanged.addHandler((grid, event) => {

                if ( grid.selectedItems ) {

                    if ( onSelect ) {

                        onSelect ( grid.selectedItems );

                    }

                }

            });

            grid.itemsSourceChanged.addHandler((grid, event) => {

                if ( grid.selectedItems ) {

                    if ( onSelect ) {

                        onSelect ( grid.selectedItems );
                        
                    }

                }

            });

        }

        if ( onInitialized ) {

            onInitialized ( grid );

        }

    };

    return <BasicCrudScreenType id="VwMsgInBox" table="VwMsgInBox" view="VwMsgInBox" {...others} onInitialized={onGridInitialized} />

}

export default VwMsgInBox;

